import { Injectable } from '@angular/core';

import { IQuickBetSaveState, IQuickBetState, defaultQuickBetState } from './quick-bet.state';

@Injectable()
export class BetslipQuickBetStateStorageService {
    constructor() {}

    fromSavedState(quickBet: IQuickBetSaveState | undefined): IQuickBetState {
        return { ...defaultQuickBetState };
    }

    toSavedState(quickBet: IQuickBetState): IQuickBetSaveState | null {
        return null;
    }
}
